import React from "react";

interface TextProps extends React.HTMLAttributes<HTMLElement>{    
  text?: string | undefined
}

class SubTitle extends React.Component<TextProps> {
  render() {
    if (!this.props.hidden)
    return (
      <div
        style={{
          color: "#333",
          fontFeatureSettings: "'ss04' on, 'ss05' on, 'ss03' on, 'ss02' on, 'ss01' on", 
          fontFamily: "FS Elliot Pro Regular",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: "400",
          lineHeight: "28px",
          display: "flex",
          paddingBottom: "0px",
          flexDirection: "column",
          alignItems: "flex-start",
          gap: "8px",
          alignSelf: "stretch"
        }}
      >
        {this.props.text}
      </div>
    );
  }
}

export default SubTitle;